import 'react-typist/dist/Typist.css'
import 'twin.macro'

import Link from 'next/link'
import React, { type FC } from 'react'

import Typical from '../../../atoms/Typical'
import { PrimarySocials } from '../../socials/PrimarySocials'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {}

const words = ['Desenvolver', 'Criar', 'Inovar', 'Colaborar', 'Transformar']

const HomeIntro: FC<Props & JSX.IntrinsicElements['section']> = (props) => (
  <section tw="w-full" {...props}>
    <h1 tw="mb-4 text-3xl font-bold tracking-tight md:text-5xl lg:text-6xl">
      Dedicado&nbsp;a{' '}
      <Typical<'span'>
        steps={words.flatMap((word) => [word, 800])}
        loop={Infinity}
        wrapper="span"
      />
    </h1>
    <p tw="my-4 leading-[1.75] text-gray-800 dark:text-gray-200">
      Olá! Eu sou <strong>Jair Rodrigues</strong>, estudante de Engenharia da
      Computação. Sou um{' '}
      <Link href="/projects" tw="underline">
        construtor
      </Link>{' '}
      &amp;{' '}
      <a
        href="https://github.com/JairRodrigue"
        target="_blank"
        rel="noopener noreferrer"
        tw="underline"
      >
        desenvolvedor
      </a>
      , explorando o mundo da tecnologia e sempre buscando aprender mais.
    </p>
    <PrimarySocials tw="my-6" />
  </section>
)

export default HomeIntro
